import wpAxios from "@/src/util/request";
import { BASE_URL } from "@/src/const/const";

export const getProvinceHasLDP = async () => {
  try {
    const res = await wpAxios().get(`${BASE_URL}/province-has-ldp`);

    return res?.data;
  } catch (error) {}
};
